// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AppDataTemplateEnum {
  export enum Type {
    ConcreteStrength = 'concrete_strength',
    ConcreteNeutralization = 'concrete_neutralization',

    Crack = 'crack',
    Peeling = 'peeling',
    Spalling = 'spalling',
    Leakage = 'leakage',
    Efflorescence = 'efflorescence',
    RebarExposure = 'rebar_exposure',

    SteelSpec = 'steel_spec',
    SteelStatus = 'steel_status',
    SteelBoltStatus = 'steel_bolt_status',
    SteelCorrosion = 'steel_corrosion',
    SteelWeldCorrosion = 'steel_weld_corrosion',
    FireproofCoating = 'fireproof_coating',

    RebarCorrosion = 'rebar_corrosion',
    RebarThickness = 'rebar_thickness',
    RebarStatus = 'rebar_status',

    Slope = 'slope',
    Subsidence = 'subsidence',

    Custom = 'custom',
  }

  export const TemplateString: { [key in Type]: string } = {
    [Type.Custom]: '사용자 정의',

    [Type.ConcreteStrength]: '콘크리트 강도',
    [Type.ConcreteNeutralization]: '콘크리트 중성화',

    [Type.Crack]: '균열',
    [Type.Peeling]: '박리',
    [Type.Spalling]: '박락 및 층분리',
    [Type.Leakage]: '누수',
    [Type.Efflorescence]: '백태',
    [Type.RebarExposure]: '철근 노출',

    [Type.SteelSpec]: '강재 규격',
    [Type.SteelStatus]: '용접 접합 상태',
    [Type.SteelBoltStatus]: '볼트 접합 상태',
    [Type.SteelCorrosion]: '강재 부식도',
    [Type.SteelWeldCorrosion]: '접합재 부식도',
    [Type.FireproofCoating]: '내화 피복',

    [Type.RebarCorrosion]: '철근 부식',
    [Type.RebarThickness]: '철근 피복 두께',
    [Type.RebarStatus]: '철근 배근 상태',

    [Type.Slope]: '기울기',
    [Type.Subsidence]: '부동침하',
  }

  export const templateList = {
    [Type.ConcreteNeutralization]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '중성화 길이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'length',
      },
      {
        label: '피복 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'thickness',
      },
      {
        label: '경과 년 수',
        type: 'value',
        unit: '년',
        column: 0,
        items: [],
        property: 'elapsed',
      },
    ],

    [Type.Crack]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '점검 단위 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'unitArea',
      },
      {
        label: '균열 발생 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'area',
      },
      {
        label: '균열 길이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'length',
      },
      {
        label: '균열 폭',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'width',
      },
    ],

    [Type.Peeling]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '박리 폭',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'width',
      },
      {
        label: '박리 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'area',
      },
      {
        label: '박리 면적률',
        type: 'value',
        unit: '%',
        column: 0,
        items: [],
        property: 'areaRatio',
      },
    ],

    [Type.Spalling]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '박락 및 층 분리 깊이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'depth',
      },
      {
        label: '박락 및 층 분리 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'area',
      },
      {
        label: '박락 및 층 분리 면적률',
        type: 'value',
        unit: '%',
        column: 0,
        items: [],
        property: 'areaRatio',
      },
    ],

    [Type.Leakage]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '점녹 상태',
        type: 'grid',
        unit: '',
        column: 2,
        items: ['누수 없음', '경미함', '현저함', '진행 관찰 가능', '진행 확연'],
        property: 'status',
      },
      {
        label: '누수 면적률',
        type: 'value',
        unit: '%',
        column: 0,
        items: [],
        property: 'areaRatio',
      },
    ],

    [Type.Efflorescence]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '백태 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'area',
      },
      {
        label: '백태 면적률',
        type: 'value',
        unit: '%',
        column: 0,
        items: [],
        property: 'areaRatio',
      },
    ],

    [Type.RebarExposure]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '철근 노출 길이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'length',
      },
      {
        label: '철근 노출 면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'area',
      },
      {
        label: '철근 노출 면적률',
        type: 'value',
        unit: '%',
        column: 0,
        items: [],
        property: 'areaRatio',
      },
    ],

    [Type.SteelSpec]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '측정 단면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'measuredArea',
      },
      {
        label: '설계 단면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'designArea',
      },
    ],

    [Type.SteelStatus]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '상태',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['매우 양호', '전반적 양호', '보통', '내력 저하 우려', '매우 불량'],
        property: 'status',
      },
      {
        label: '측정 단면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'measuredArea',
      },
      {
        label: '설계 단면적',
        type: 'value',
        unit: '㎡',
        column: 0,
        items: [],
        property: 'designArea',
      },
    ],

    [Type.SteelBoltStatus]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '너트 누락 또는 풀림이 발생한 접합부 수',
        type: 'value',
        unit: '개',
        column: 0,
        items: [],
        property: 'looseBoltCount',
      },
      {
        label: '부족 토크치',
        type: 'value',
        unit: 'N/m',
        column: 0,
        items: [],
        property: 'measuredTorque',
      },
      {
        label: '설계 토크치',
        type: 'value',
        unit: 'N/m',
        column: 0,
        items: [],
        property: 'designTorque',
      },
    ],

    [Type.SteelCorrosion]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '측정 판 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'yhickness',
      },
      {
        label: '부식 상태',
        type: 'value',
        unit: '',
        column: 0,
        items: [],
        property: 'corrosion',
      },
    ],

    [Type.SteelWeldCorrosion]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '측정 용접재 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'thickness',
      },
      {
        label: '용접재 부식 환경',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['건조', '습윤', '부식성', '고부식성'],
        property: 'env',
      },
      {
        label: '측정 접합판재 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'jointThickness',
      },
      {
        label: '접합판재 부식 환경',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['건조', '습윤', '부식성', '고부식성'],
        property: 'jointEnv',
      },
    ],

    [Type.FireproofCoating]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 3,
        items: ['기둥', '큰 보', '작은 보'],
        property: 'part',
      },
      {
        label: '측정 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'measuredThickness',
      },
      {
        label: '손상 여부',
        type: 'grid',
        unit: '',
        column: 2,
        items: ['손상 안됨', '손상됨'],
        property: 'damageStatus',
      },
    ],

    [Type.RebarCorrosion]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['기둥', '내력벽', '큰 보', '작은 보', '슬래브', '테두리보', '접합부'],
        property: 'part',
      },
      {
        label: '점녹 상태',
        type: 'grid',
        unit: '',
        column: 2,
        items: [
          '녹이 없거나 약간의 점녹 발생',
          '광범위하게 발생',
          '면녹과 부분적인 들뜬 녹',
          '들뜬 녹(20% 이하)',
          '층상 녹(20% 이하)',
        ],
        property: 'rustStatus',
      },
      {
        label: '부식 환경',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['건조', '습윤', '부식성', '고부식성'],
        property: 'corrosionEnv',
      },
      {
        label: '철근 직경',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'rebarDiameter',
      },
      {
        label: '자연전위법 전위값',
        type: 'value',
        unit: 'V',
        column: 0,
        items: [],
        property: 'potentialValue',
      },
    ],

    [Type.RebarThickness]: [
      {
        label: '부재',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['슬래브', '보', '기둥', '벽체'],
        property: 'part',
      },
      {
        label: '피복 두께',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'thickness',
      },
    ],

    [Type.Slope]: [
      {
        label: '기울기 방향',
        type: 'grid',
        unit: '',
        column: 4,
        items: ['좌측', '우측'],
        property: 'direction',
      },
      {
        label: '변위값',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'value',
      },
      {
        label: '측정 높이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'height',
      },
    ],

    [Type.Subsidence]: [
      {
        label: '측정값 - 단부1',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'point1',
      },
      {
        label: '측정값 - 단부2',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'point2',
      },
      {
        label: '측정값 - 중앙부',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'center',
      },
      {
        label: '측정 수평 길이',
        type: 'value',
        unit: 'mm',
        column: 0,
        items: [],
        property: 'length',
      },
    ],
  }
}
